import React, { Component, Children } from 'react';
import classNames from 'classnames'
import PropTypes from 'prop-types';
import _keys from 'lodash/keys';
import { getLocale } from '@utils';
import * as validate from '@utils/validate';

export const rules = {
  ...validate,
  isRequired: (str) => !!str,
}

const messages = require('../../../resources/messages.json');

export default class ValidateForm extends Component {

  static propTypes = {
    rules: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    autoValidate: PropTypes.bool,
    isOk: PropTypes.bool,
  }

  constructor(props) {
    const extraRules = Array.isArray(props.rules) ? props.rules.reduce((acc, cur) => ({ ...acc, [cur]: () => false }), {}) : props.rules;
    super(props);
    this.state = {
      hasError: false,
      errors: {}
    };
    this.rules = {
      ...rules,
      ...extraRules,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.autoValidate) {
      this.validate(nextProps.children); // auto validate
    }
    return true;
  }

  validate(children = this.props.children, callback) {
    const { rules } = this;
    let hasError = false;
    let errors = {};
    React.Children.forEach(children, (child) => {
      const { props, type } = child
      const { name, value } = props
      // check the child type. should only accept the input elements
      if (name && (type === 'input' || typeof type === 'function')) {
        const errorCodes = _keys(props)
          .filter(key => /^data-error-/.test(key))
          .reduce((codes, key) => {
            const rule = key.split('-')[2]
            if (props[key] && rules[rule] && !rules[rule](value)) {
              hasError = true
              return [...codes, rule]
            } else {
              return codes
            }
          }, [])

        if (errorCodes.length > 0) {
          errors[name] = errorCodes
        }
      }
    });
    this.setState({
      hasError: hasError,
      errors: errors
    });
    if ( callback ) {
      callback({
        hasError: hasError,
        errors: errors
      })
    } else {
      return {
        hasError: hasError,
        errors: errors
      };
    }
  }

  render() {
    const { errors } = this.state;
    const wrappedChildren = React.Children.map(this.props.children, (child) => {
      // check the child type. should only accept these elements
      if (child.type === 'input' || typeof child.type === 'function') {
        if (errors[child.props.name]) {
          return (
            <div className='error'>
              { child }
              { child.props.placeholder && <label>{child.props.placeholder}</label> }
              <div className='message'>{messages['form'][errors[child.props.name][0]][getLocale()]}</div>
            </div>
          );
        } else {
          return (
            <div className='ok'>
              { child }
              { child.props.placeholder && <label>{child.props.placeholder}</label> }
            </div>
          );
        }
      } else {
        return child;
      }
    });
    return (
      <div className={classNames('field', 'floating', { ok: this.props.isOk })}>
        { wrappedChildren }
      </div>
    )
  }
}
